import { render, staticRenderFns } from "./AUniversidades.vue?vue&type=template&id=1cebe4df"
import script from "./AUniversidades.vue?vue&type=script&lang=js"
export * from "./AUniversidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports